module.exports = __webpack_public_path__ + "img/Balkon02.9c366ae1.webp";